// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OEM, User } from '@interfaces/user.interfaces';
import { DealershipService } from '@services/dealership.service';
import { takeWhile } from 'rxjs';
import { tenantIsStellantis } from 'src/app/utils/utils';

@Component({
    selector: 'dealer-tenant-header',
    templateUrl: './dealer-tenant-header.component.html',
    styleUrls: ['./dealer-tenant-header.component.scss'],
})
export class DealerTenantHeaderComponent implements OnInit, OnDestroy {
    public companyImage: string = null;
    public productImage: string = null;
    private isComponentAlive = true;
    public user: User;

    constructor(
        private readonly dealershipService: DealershipService,
        private readonly router: Router
    ) {}

    ngOnInit(): void {
        this.setImages();
        this.oemChange();
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }

    private oemChange(): void {
        this.dealershipService.dealershipUpdate$.pipe(takeWhile(() => this.isComponentAlive)).subscribe((dealer) => {
            if (dealer.oemCode === OEM.stellantis) {
                this.companyImage = '../../assets/img/stellantis-logo-white.png';
                this.productImage = '../../assets/img/ez-docs-logo-white.png';
            } else {
                this.companyImage = '../../assets/img/1-ez-docs-white.png';
                this.productImage = '../../assets/img/cropped-ud-logo-white.png';
            }
        });
    }

    private setImages(): void {
        if (tenantIsStellantis()) {
            this.companyImage = '../../assets/img/stellantis-logo-white.png';
            this.productImage = '../../assets/img/ez-docs-logo-white.png';
        } else {
            this.companyImage = '../../assets/img/1-ez-docs-white.png';
            this.productImage = '../../assets/img/cropped-ud-logo-white.png';
        }
    }

    public routeToHome() {
        //Function Used to  Route User to Whatever Their Default Home Page Is - But due to permissions we changed this to just take user to Leads Page

        this.router.navigateByUrl('/dashboard/leads');
    }
}
